import { render } from "./AboutLink.vue?vue&type=template&id=36da697e&scoped=true"
import script from "./AboutLink.vue?vue&type=script&lang=ts"
export * from "./AboutLink.vue?vue&type=script&lang=ts"

import "./AboutLink.vue?vue&type=style&index=0&id=36da697e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-36da697e"

export default script